import {IFeature} from "./Feature";
import './FeatureCard.css'

export interface IFeatureCardProps {
    feature: IFeature
}

export default function FeatureCard(props: IFeatureCardProps) {
    var className = "Feature_card_image_top"
    if (props.feature.image_style === "rounded") {
        className = "Feature_card_image_rounded"
    } else if (props.feature.image_style === "bottom") {
        className = "Feature_card_image_bottom"
    } else if (props.feature.image_style === "center") {
        className = "Feature_card_image_center"
    }
    return <div className="Feature_card_container">
        <div className="Feature_card" style={{paddingRight: props.feature.image_style == "rounded" ? "16px" : "0px"}}>
            <div className="Feature_card_left_content">
                <div className="Feature_card_title">
                    {props.feature.title}
                </div>
                <div className="Feature_card_subtitle">
                    {props.feature.subtitle}
                </div>
            </div>
            <img src={props.feature.image} className={className}/>
        </div>
        <div className="Car_card_shadow"/>
    </div>
}